import React from 'react';
import { connect } from 'react-redux';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../../redux/store';
import GridCellWrapper from '../../../../../components/grid-cell-wrapper/GridCellWrapper';

import InputFieldText from '../../../../../components/input/floating-label/input-field/InputFieldText';
import { setSpotpreisnr } from '../../../../../redux/actions/auftragserfassung';

interface SpotpreisProps {
  auftragserfassung: StateModel_Auftragserfassung;
  setSpotpreisnr: (value: string | undefined) => void;
}

/**
 * Component fuer die Spotpreis.
 *
 * @returns {JSX.Element}
 */
const Spotpreis = (props: SpotpreisProps) => {
  //  useEffect(() => {}, []);

  return (
    <GridCellWrapper
      classes='spotpreis'
      label='Spot-Preis Nr.'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <InputFieldText
        maxlength={256}
        tooltip={'max. 256 Zeichen'}
        label='Spot-Preis Nr.'
        classes='spotpreisnr'
        onChangeHandler={props.setSpotpreisnr}
        value={props.auftragserfassung.spotpreisnr}
      />
    </GridCellWrapper>
  );
};
// zieht die Sachen aus dem redux State, damit sie hier benutzt werden können
const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
});

export default connect(mapStateToProps, {
  setSpotpreisnr,
})(Spotpreis);
